import React, { useState } from 'react';
import { ShapeAnnotation, ShapeHighlight, ShapeRedaction, useDocumentPermissions } from "../../index.js";
import { useViewerState } from "../../hooks/index.js";
/**
 * Defined the component's own properties
 */
export const ShapeSkeleton = props => {
  const permissions = useDocumentPermissions();
  const viewerState = useViewerState();
  const [focused, setFocused] = useState(false);

  /**
   * Method that returns the shape dimensions as CSS properties
   * @param shape the shape instance
   * @param offsetX optional X offset
   * @param offsetY optional Y offset
   */
  const getShapeDimensions = (shape, offsetX = 0, offsetY = 0) => {
    return {
      top: shape.y * props.zoomRatio + offsetY * props.zoomRatio,
      left: shape.x * props.zoomRatio + offsetX * props.zoomRatio,
      width: shape.w * props.zoomRatio,
      height: shape.h * props.zoomRatio
    };
  };

  /** event that will be triggered on resize */
  const onResized = clientRect => {
    if (clientRect && (viewerState.boxPosition.bottom || viewerState.boxPosition.left || viewerState.boxPosition.right || viewerState.boxPosition.top)) {
      const {
        shape,
        shapeType,
        zoomRatio
      } = props;
      const newSize = {
        w: clientRect.right < viewerState.pagesRects[props.visiblePagesIndex].pageRect.right && clientRect.right < viewerState.boxPosition.right ? clientRect.width / zoomRatio : (Math.min(viewerState.pagesRects[props.visiblePagesIndex].pageRect.right, viewerState.boxPosition.right) - clientRect.x) / zoomRatio,
        h: clientRect.bottom < viewerState.pagesRects[props.visiblePagesIndex].pageRect.bottom && clientRect.height < viewerState.boxPosition.bottom ? clientRect.height / zoomRatio : (Math.min(viewerState.pagesRects[props.visiblePagesIndex].pageRect.bottom, viewerState.boxPosition.bottom) - clientRect.y) / zoomRatio
      };
      props.updateShapeData(shapeType, shape.guid, {
        ...shape,
        w: newSize.w,
        h: newSize.h
      }, true);
      return newSize;
    }
    return undefined;
  };

  /** onDragStart event handler for the Shape instance */
  const onDragStart = ev => {
    ev.dataTransfer.setData('shape', JSON.stringify({
      type: props.shapeType,
      shape: props.shape,
      offset: {
        width: ev.clientX - ev.currentTarget.getBoundingClientRect().left,
        height: ev.clientY - ev.currentTarget.getBoundingClientRect().top
      }
    }));
  };

  /** onKeyPress event handler for deleting shapes */
  const handleKeyPress = ev => {
    switch (ev.key) {
      case 'Backspace':
      case 'Delete':
        permissions.canEdit && props.removeShape(props.shapeType, props.shape.guid);
        break;
      default:
        break;
    }
  };

  /** onFocus event handler that updates the 'focused' property */
  const onFocus = () => {
    setFocused(true);
  };

  /** onBlur event handler that updates the 'focused' property */
  const onBlur = ev => {
    setFocused(false);
    if (props.shapeType === 'annotations') {
      var _ev$currentTarget$inn;
      props.updateShapeData('annotations', props.shape.guid, {
        ...props.shape,
        text: (_ev$currentTarget$inn = ev.currentTarget.innerText) === null || _ev$currentTarget$inn === void 0 ? void 0 : _ev$currentTarget$inn.trim()
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    onClickCapture: ev => ev.stopPropagation(),
    style: {
      filter: focused ? 'contrast(.9) brightness(1.1)' : ''
    },
    onFocus: onFocus,
    onKeyUp: ev => props.shapeType !== 'annotations' && handleKeyPress(ev),
    onBlur: ev => props.rotationDegree === 0 && onBlur(ev)
  }, props.shapeType === 'annotations' ? /*#__PURE__*/React.createElement(ShapeAnnotation, {
    shape: props.shape,
    zoomRatio: props.zoomRatio,
    onDragStart: ev => props.rotationDegree === 0 && onDragStart(ev),
    onResized: ev => {
      if (props.rotationDegree === 0) {
        return onResized(ev);
      } else {
        return undefined;
      }
    },
    getShapeDimensions: getShapeDimensions,
    updateShapeData: props.updateShapeData,
    removeShape: props.removeShape,
    rotationDegree: props.rotationDegree
  }) : props.shapeType === 'redactions' ? /*#__PURE__*/React.createElement(ShapeRedaction, {
    zoomRatio: props.zoomRatio,
    removeShape: props.removeShape,
    shape: props.shape,
    onDragStart: ev => props.rotationDegree === 0 && onDragStart(ev),
    onResized: ev => {
      if (props.rotationDegree === 0) {
        return onResized(ev);
      } else {
        return undefined;
      }
    },
    permissions: permissions,
    dimensions: getShapeDimensions(props.shape),
    rotationDegree: props.rotationDegree
  }) : /*#__PURE__*/React.createElement(ShapeHighlight, {
    zoomRatio: props.zoomRatio,
    removeShape: props.removeShape,
    shape: props.shape,
    onDragStart: ev => props.rotationDegree === 0 && onDragStart(ev),
    onResized: ev => {
      if (props.rotationDegree === 0) {
        return onResized(ev);
      } else {
        return undefined;
      }
    },
    dimensions: getShapeDimensions(props.shape),
    rotationDegree: props.rotationDegree
  }));
};
//# sourceMappingURL=shape-skeleton.js.map